import { getPropertyAddress } from "./verifier";

// Same owner is property.owner.email, compared case-insensitively. Before the
// dashboard hydrates the owner record, property.owner is that email string.
// Email is the users-table key; owner id is not used.
//
// Archived properties are skipped.
//
// Accounts with the same type, provider, and userName (trimmed, case-insensitive)
// become one entry listing every source property. A different password stays
// separate so a credential is not hidden. The first account supplies the shown fields.
export function getSiblingAccounts(properties, currentPropertyId) {
	if (!Array.isArray(properties) || currentPropertyId == null || currentPropertyId === "") return [];

	const current = properties.find((property) => property && String(property.id) === String(currentPropertyId));
	const owner = ownerKey(current);
	if (!owner) return [];

	const grouped = new Map();
	properties.forEach((property) => {
		if (!property || String(property.id) === String(currentPropertyId) || property.archived) return;
		if (ownerKey(property) !== owner) return;

		const accounts = Array.isArray(property.accounts) ? property.accounts : [];
		accounts.forEach((account) => {
			if (!account) return;
			const source = {
				sourcePropertyId: property.id,
				sourcePropertyAddress: getPropertyAddress(property),
			};
			const existing = grouped.get(accountIdentity(account));
			if (existing) {
				const alreadyListed = existing.sources.some((item) => String(item.sourcePropertyId) === String(source.sourcePropertyId));
				if (!alreadyListed) existing.sources.push(source);
				return;
			}
			grouped.set(accountIdentity(account), {
				account,
				sourcePropertyId: source.sourcePropertyId,
				sourcePropertyAddress: source.sourcePropertyAddress,
				sources: [source],
			});
		});
	});

	return [...grouped.values()];
}

function ownerKey(property) {
	const owner = property?.owner;
	if (!owner) return "";
	if (typeof owner === "string") return owner.trim().toLowerCase();
	if (owner.email) return String(owner.email).trim().toLowerCase();
	return "";
}

function accountIdentity(account) {
	const type = String(account.type || "").trim().toLowerCase();
	const provider = String(account.provider || "").trim().toLowerCase();
	const userName = String(account.userName || "").trim().toLowerCase();
	const password = String(account.password ?? "");
	return `${type}\0${provider}\0${userName}\0${password}`;
}
